import { createRoot } from 'react-dom/client';
import { CalculatorProps } from './calculator';
import { createElement } from 'react';
import { WrappedCalculator } from './wrapped-calculator';

const appElement = document.getElementById('calculator');
if (appElement) {
  const props: CalculatorProps = {
    audienceSize: 3,
    popularity: 2,
    currencyName: 'USD',
    tiers: [
      { id: crypto.randomUUID(), amount: 2, pledgers: 1200 },
      { id: crypto.randomUUID(), amount: 10, pledgers: 1000 },
      { id: crypto.randomUUID(), amount: 20, pledgers: 100 },
    ],
    frequencyName: 'monthly',
    albumSales: 50,
    avgSalePrice: 20,
  };
  try {
    if (window.location.search.length !== 0) {
      const initialData = JSON.parse(
        atob(decodeURIComponent(window.location.search.substring(1)))
      );
      // props.audienceSize = initialData.a;
      // props.popularity = initialData.p;
      if (initialData.c) props.currencyName = initialData.c;
      if (initialData.f) props.frequencyName = initialData.f;
      if (initialData.t) props.tiers = initialData.t;
      if (initialData.s) props.avgSalePrice = initialData.s;
      if (initialData.m) props.albumSales = initialData.m;
    }
  } catch (e) {
    console.log('error', e);
  }
  const root = createRoot(appElement);
  // createRoot(container!) if you use TypeScript
  root.render(createElement(WrappedCalculator, props));
}
